(function($){
	// Handle the mobile menu toggling
	$('#nav-icon').click(function() {
		mainNav();
	});

	$('.mobile-primary a').click(function() {
		mainNav();
	})

	function mainNav() {
		$('.main-menu-toggle').toggleClass('cross');
		$('body').toggleClass('modal-open');
		$('#mobile-navigation').toggleClass('open');
	}

})(jQuery);
